module.exports = __webpack_public_path__ + "static/media/Angel-Aura.0577dc71.png";